module.exports = __webpack_public_path__ + "img/share3.3199a322.3199a322.svg";